import { z } from "zod";

export const PROD_ORDER_STATUSES = ["InTransit", "AtVendor", "Complete", "NoActivity"] as const;
export type ProdOrderStatus = (typeof PROD_ORDER_STATUSES)[number];

export const expediteSchema = z.object({
  containerIds: z.array(z.number().int()).min(1),
  priority: z.enum(["Normal", "High", "Critical"]),
  message: z.string().optional(),
});
export type ExpediteInput = z.infer<typeof expediteSchema>;

export const receiptSchema = z.object({ containerId: z.number().int() });
export const shipmentSchema = z.object({ containerId: z.number().int() });
